import { Keyboard, X } from 'lucide-react';

const SHORTCUTS = [
  { keys: ['Ctrl', '⌘K'], action: 'Abrir command palette' },
  { keys: ['g', 'd'],     action: 'Dashboard' },
  { keys: ['g', 'p'],     action: 'Pipeline' },
  { keys: ['g', 'c'],     action: 'Contas' },
  { keys: ['?'],          action: 'Esta tela' },
  { keys: ['Esc'],        action: 'Fechar modal' },
];

export default function ShortcutsModal({ open, onClose }) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 bg-black/60 z-[200] flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-[#002233] border border-[#00DBFF]/20 rounded-xl shadow-2xl w-full max-w-md overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b border-white/10">
          <div className="flex items-center gap-2 text-white">
            <Keyboard size={16} className="text-[#00DBFF]" />
            <span className="text-sm font-semibold">Atalhos de teclado</span>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-white/30 hover:text-white/70 transition-colors"
            aria-label="Fechar"
          >
            <X size={18} />
          </button>
        </div>

        <div className="p-4 space-y-1">
          {SHORTCUTS.map(({ keys, action }) => (
            <div key={action} className="flex items-center justify-between py-2 px-1">
              <span className="text-sm text-white/70">{action}</span>
              <div className="flex items-center gap-1">
                {keys.map((k, i) => (
                  <span key={i} className="flex items-center gap-1">
                    <kbd className="inline-block px-1.5 py-0.5 text-[11px] font-mono bg-white/10 text-white/80 border border-white/20 rounded">
                      {k}
                    </kbd>
                    {i < keys.length - 1 && <span className="text-white/30 text-xs">then</span>}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
